import React from 'react';
import PropTypes from 'prop-types';

function ShareButton({ active, activeColor, border, color }) {
  return (
    <>
      <path
        d="M222.116 142.37C221.6 142.376 221.078 142.434 220.553 142.548L218.81 142.926C214.617 143.834 211.972 147.942 212.881 152.136L217.366 172.823C218.275 177.017 222.383 179.661 226.576 178.752L228.32 178.373C232.514 177.464 235.158 173.356 234.249 169.163L229.764 148.476C228.968 144.807 225.724 142.324 222.116 142.37Z"
        fill={active ? activeColor : color}
      />
      <path
        d="M572.782 130.338V131.694H583.539V130.338H572.782ZM220.139 130.601V138.01H221.495V130.601H220.139ZM214.967 133.306L213.792 133.985L216.733 139.079L217.909 138.402L214.967 133.306ZM226.669 133.306L223.727 138.402L224.901 139.079L227.843 133.985L226.669 133.306ZM572.782 133.941V135.297H583.539V133.941H572.782ZM572.782 137.543V138.899H583.539V137.543H572.782Z"
        fill={border}
      />
      <path
        d="M222.106 141.642C221.542 141.65 220.971 141.712 220.399 141.837L218.654 142.216C214.079 143.208 211.176 147.716 212.168 152.291L216.653 172.977C217.645 177.553 222.153 180.455 226.728 179.463C226.73 179.463 226.731 179.463 226.733 179.463L228.473 179.084C233.049 178.092 235.951 173.584 234.959 169.009L230.474 148.323C229.606 144.319 226.053 141.593 222.106 141.642ZM222.125 143.098C225.393 143.056 228.329 145.296 229.052 148.631L233.537 169.317C234.363 173.128 231.976 176.835 228.165 177.662L226.42 178.041C222.609 178.867 218.902 176.481 218.076 172.669L213.595 151.983C212.769 148.172 215.15 144.465 218.962 143.638L220.707 143.259C221.183 143.156 221.658 143.103 222.125 143.098Z"
        fill="#E5152D"
      />
    </>
  );
}

ShareButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

ShareButton.defaultProps = {
  active: false,
  activeColor: '#000000',
  border: '#919191',
  color: '#DEE2EB',
};

export default ShareButton;
